import React from 'react'
import PropTypes from 'prop-types'
import request from 'superagent'
import R from 'ramda'

import { AUTH_API_URL } from '_constants'
import { isNilOrEmpty } from '_utils'

import {
  Container,
  Segment,
  Dimmer,
  Form,
  Message,
  Loader
  // Menu,
  // Icon
} from 'semantic-ui-react'

import BaseInputField from '_forms/baseInput'
import Order from './order'

class SearchOrders extends React.PureComponent {
  state ={
    orderId: ''
  }
  onChange = (_e, data) => this.setState({[data.name]: data.value})
  onSubmit = (_e, _data) => this.props.onSubmit(this.state.orderId)

  render = () => (
    <Form onSubmit={this.onSubmit} ref={el => { this.formEl = el }}>
      <Form.Group>
        <BaseInputField width={5} name='orderId'
          type='text'
          value={this.state.orderId}
          onChange={this.onChange}
          labelTxt='Fastspring contextual order id'
          popupTxt='Enter the FS contextual order id for the order you wish to change.'
        />
      </Form.Group>
    </Form>
  )
}

SearchOrders.propTypes = {
  onSubmit: PropTypes.func.isRequired
}

const OrderError = ({orderId, error}) => error
  ? <Message negative><Message.Header>{error}</Message.Header></Message>
  : <Message negative>
    <Message.Header>Cannot find order</Message.Header>
    <p>Please check that order id {orderId} is valid</p>
  </Message>

OrderError.propTypes = {
  orderId: PropTypes.string.isRequired,
  error: PropTypes.string
}

const OrderOrError = ({order, error, orderId}) => error
  ? <OrderError error={error} orderId={orderId} />
  : order
    ? <Order order={order} />
    : null

OrderOrError.propTypes = {
  order: PropTypes.object,
  error: PropTypes.string,
  orderId: PropTypes.string.isRequired
}

const displayNone = {display: 'none'}
class FastspringPage extends React.PureComponent {
  state = {
    isLoading: false,
    orderId: '',
    order: null,
    error: null
  }
  onSubmit = orderId => isNilOrEmpty(orderId.trim())
    ? null
    : this.setState({isLoading: true, error: null, order: null, orderId}, () => request
      .get(`${AUTH_API_URL}/fastspring/orders?orderId=${orderId}`)
      .set('Content-Type', 'application/json')
      .set('Accept', 'application/json')
      .withCredentials()
      .then(R.tap(res => console.log(res.body)))
      .then(res => this.setState({isLoading: false, order: res.body}))
      .catch(err => this.setState({isLoading: false, error: R.path(['response', 'body', 'error'], err) || err.message}))
    )

  render = () => (
    <Container textAlign='left' fluid style={this.props.display ? {} : displayNone} >
      <Message warning>
        <Message.Header>Fastpring Order Adjustments</Message.Header>
        <Message.List>
          <Message.Item>Collect the required info for the desired product (eg. for Academic upgrade, collect image id, school name, student or teacher, and either a Max 7 license or Max 2-6 Serial Number</Message.Item>
          <Message.Item>Send the user a custom purchase url from FS</Message.Item>
          <Message.Item>After the user purchases, search for the Order by id below and enter the required fields</Message.Item>
          <Message.Item>After you save the info here with success, go to the order in FS and hit OPTIONS-&gt;Resend Notifications</Message.Item>
        </Message.List>
      </Message>
      <SearchOrders onSubmit={this.onSubmit} />
      <Segment basic>
        <Dimmer inverted active={this.state.isLoading === true}>
          <Loader />
        </Dimmer>
        <OrderOrError order={this.state.order} error={this.state.error} orderId={this.state.orderId} />
      </Segment>
    </Container>
  )
}

FastspringPage.propTypes = {
  display: PropTypes.bool.isRequired,
  // mapStateToProps
  goToPage: PropTypes.func.isRequired
}

export default FastspringPage



// WEBPACK FOOTER //
// ./webAdmin/components/fastspring/page.js